document.addEventListener("DOMContentLoaded", function () {

  const swiper = new Swiper(".oxygenMainSlider", {
    slidesPerView: 1,
    spaceBetween: 10,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const thumbs = document.querySelectorAll(".oxygen-thumb");

  thumbs.forEach((thumb, index) => {

    thumb.addEventListener("click", function () {

      swiper.slideTo(index);

      document
        .querySelectorAll(".oxygen-thumb")
        .forEach((item) => {
          item.classList.remove("active");
        });

      this.classList.add("active");

    });

  });

});